// extracted by mini-css-extract-plugin
export var addButton = "_md-0";
export var border = "_md-8";
export var check = "_md-h";
export var danger = "_md-6";
export var dropdownContainer = "_md-1";
export var editModalBody = "_md-j";
export var footerContainer = "_md-i";
export var fullWidth = "_md-a";
export var hide = "_md-9";
export var icon = "_md-3";
export var input = "_md-7";
export var inputFlex = "_md-b";
export var inputWrapper = "_md-c";
export var manualFocus = "_md-5";
export var optionButton = "_md-4";
export var pillWrapper = "_md-e";
export var pointer = "_md-2";
export var showOverflow = "_md-f";
export var tagsFlex = "_md-d";
export var xButton = "_md-g";